export const blockthroughTag =
	'<script async src="https://btloader.com/tag?o=5751365725323264&upapi=true"></script>';
